import { css } from "styled-components";
const getBreakpoints = (breakpoints) => Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (literals, ...placeholders) => css`
      @media (max-width: ${breakpoints[label]}) {
        ${css(literals, ...placeholders)};
      }
    `;
  return acc;
}, {});
export {
  getBreakpoints
};
